var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetchEpisodes from '@tving/utils/src/apis/episodes/fetchEpisodes';
import fetchMyLastsTv from '@tving/utils/src/apis/myLastsTv/fetchMyLastsTv';
import { DEVICE_TYPE } from '@tving/utils/src/constants/commonConstants';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
import DeviceManagerInstance from '@tving/utils/src/utils/device';
import getStartDate from '@tving/utils/src/utils/proxy-util/getStartDate';
import TvingNavigator from '@tving/utils/src/utils/rotuer/TvingNavigator';
import TvingEventDelegator from '@tving/utils/src/utils/tving-event-delegator/TvingEventDelegator';
import TvingLogModule from '@tving/utils/src/utils/tving-log-module/TvingLogModule';
export var EventDelegator = new TvingEventDelegator();
export var PageNavigator = new TvingNavigator('/profile');
export var twoDepth = function (account) {
    var doTwoDepth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deviceType, twoDepthData, _a, popularProgramsParameter, tizenDeviceManager, popularProgramsBody, popularPrograms, lastEpisodes, lastEpisodesParameter, lastEpisodesBody, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    deviceType = getDeviceType();
                    twoDepthData = '';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 8, , 9]);
                    _a = deviceType;
                    switch (_a) {
                        case DEVICE_TYPE.WEBOS: return [3 /*break*/, 2];
                        case DEVICE_TYPE.TIZEN: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 7];
                case 2:
                    {
                        twoDepthData = (account === null || account === void 0 ? void 0 : account.userToken) || '';
                        return [3 /*break*/, 7];
                    }
                    _b.label = 3;
                case 3:
                    popularProgramsParameter = {
                        order: 'viewDay',
                    };
                    tizenDeviceManager = DeviceManagerInstance;
                    return [4 /*yield*/, fetchEpisodes(popularProgramsParameter)];
                case 4:
                    popularProgramsBody = _b.sent();
                    popularPrograms = popularProgramsBody === null || popularProgramsBody === void 0 ? void 0 : popularProgramsBody.result;
                    lastEpisodes = [];
                    if (!(account && account.profileToken)) return [3 /*break*/, 6];
                    lastEpisodesParameter = {
                        order: 'new',
                        viewTimeCutYn: 'N',
                        cache: 'Y',
                        lastFrequency: 'Y',
                        contentType: 'episode',
                        apiUserToken: account.profileToken,
                        startDate: getStartDate(),
                    };
                    return [4 /*yield*/, fetchMyLastsTv(lastEpisodesParameter)];
                case 5:
                    lastEpisodesBody = _b.sent();
                    lastEpisodes = lastEpisodesBody === null || lastEpisodesBody === void 0 ? void 0 : lastEpisodesBody.result;
                    _b.label = 6;
                case 6:
                    twoDepthData = tizenDeviceManager.generateTwoDepthData(popularPrograms, lastEpisodes);
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_1 = _b.sent();
                    TvingLogModule.error('twoDepth error', e_1);
                    return [3 /*break*/, 9];
                case 9:
                    DeviceManagerInstance.twoDepth(twoDepthData);
                    return [2 /*return*/];
            }
        });
    }); };
    void doTwoDepth();
};
